import { Alert, Button, Checkbox, Form, Input, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { HouseAdSizeBean, HouseCreativeBean } from 'src/api/api';
import { formDataLoader, FormDataType } from 'src/util/FormDataLoader';
import houseCreativeApi from './HouseCreativeApi';

const FormItem = Form.Item
const Option = Select.Option

interface Props {

}

const formInfoItems: FormDataType[] = [
    FormDataType.AdSizeList
]

const FormatEnum = HouseCreativeBean.FormatEnum
const PositionEnum = HouseCreativeBean.PositionEnum

export const HouseCreativeEdit: React.FC<Props> = () => {

    const [form] = useForm()

    const [error, setError] = useState()
    const [info, setInfo] = useState({
        adSizeList: []
    })

    const history = useHistory()

    const { id } = useParams<{ id?: string }>()

    const handleSubmit = () => {
        form.validateFields().then(values => {
            houseCreativeApi
                .edit(Number.parseInt(id ?? '-1'), { ...values })
                .then(history.goBack)
                .catch(err => {
                    setError(err.error)
                })
        })
    }

    useEffect(() => {
        houseCreativeApi
            .view(Number.parseInt(id ?? '-1'))
            .then(itemResponseHouseCreativeBeanObject => {
                const bean = itemResponseHouseCreativeBeanObject.data
                if (!bean) {
                    return
                }
                form.setFieldsValue(bean)
                formDataLoader(...formInfoItems)
                    .then(formInfo => setInfo(formInfo as any))
            })
            .catch(err => {
                setError(err.error)
            })
    }, [])

    return (
        <Form
            style={{
                maxWidth: '1000px'
            }}
            onFinish={handleSubmit}
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
        >
            {error ? <Alert message={error} type="error" /> : null}
            <FormItem
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input HouseCreative name'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Name"
                tooltip={'Name of the HouseCreative'}
            >
                <Input />
            </FormItem>
            <FormItem
                name="format"
                rules={[
                    {
                        required: true,
                        message: 'Please select Format'
                    }
                ]}
                label="Format"
                tooltip={'Format type'}
            >
                <Select placeholder="Select Format" >
                    {Object
                        .keys(FormatEnum)
                        .map((mode) => <Option key={mode} value={mode}>{mode}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue={true}
                tooltip={'If true it will be used for House Bidding'}
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="adCode"
                label="Ad Code"
                rules={[
                    {
                        required: true,
                        message: 'Please enter Ad Code'
                    }
                ]}
                tooltip={'Html code of banner'}
            >
                <TextArea rows={4} />
            </FormItem>
            <FormItem
                name="secure"
                label="Secure"
                valuePropName="checked"
                initialValue={true}
                tooltip={'If true it will be used for all requests, else only for http'}
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="position"
                label="Position"
            >
                <Select
                    allowClear
                    mode="multiple"
                    placeholder="Select position">
                    {Object.values(PositionEnum).map(position =>
                        <Option key={position} value={position}>{position}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="houseAdSize"
                label="Ad Size"
                tooltip={'Available Ad Sizes'}
            >
                <Select
                    showSearch
                    allowClear
                    placeholder="Select Ad Size"
                >
                    {info.adSizeList.map((item: HouseAdSizeBean) => <Option key={item.id} value={item.id as number}>{item.name}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                wrapperCol={{
                    offset: 11, span: 6
                }}>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" htmlType="submit">Save</Button>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" danger htmlType="button" onClick={history.goBack}>Cancel</Button>
            </FormItem>
        </Form>
    )
}
